/* eslint-disable */
/* this file is generated by generateIcons script */

import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class InstallPolicyCloudIcon extends BaseIcon {
  getChildren = () => [ <g><g><g><path d="M13.1,7.7c0.1-0.2,0.1-0.4,0.1-0.6C13.3,4.9,11.5,3,9.3,3C7.6,3,6,4.2,5.6,5.8C5.2,5.7,4.9,5.6,4.5,5.6 			C2.5,5.7,1,7.3,1,9.3S2.5,13,4.5,13h7.9c1.5,0,2.6-1.2,2.6-2.7C15,9.1,14.3,8,13.1,7.7z M8,12L5,9h2V7c0-0.6,0.4-1,1-1s1,0.4,1,1 			v2h2L8,12z" fill={this.getColor()}/></g></g></g> ]
  getViewBox = () => '0 0 16 16'
}
